import React from 'react';
import { DeactivationModalProps } from './deactivation-modal.types';
import { Button, Flex, Text } from '../../../../common/common-components.styled';
import { leasingOfferRequestConfig } from '../../../../request-config/leasing-offer/leasing-offer.request-config';
import { ReactQueryKeys } from '../../../../common/enums';
import { useQueryClient } from 'react-query';
import { useFetch } from '../../../../hooks/use-fetch/use-fetch';
import ThinArrowLeft from '../../../../components/icons-new/thin-arrow-left';

const DeactivationModal = ({
  leasingOffersId,
  clearCheckedLeasingOffers,
  setIsLoading,
  closeAlert
}: DeactivationModalProps) => {
  const queryClient = useQueryClient();
  const { fetch } = useFetch({ isShowLoading: false, isShowSuccessSnackbar: true });

  const deactivateLeasingOffers = async () => {
    setIsLoading(true);
    closeAlert();
    await fetch({
      requestConfig: leasingOfferRequestConfig.deactivateLeasingOffers(leasingOffersId),
      callback: () => {
        queryClient.resetQueries([ReactQueryKeys.GetMassDataLeasingOffers]);
        queryClient.resetQueries([ReactQueryKeys.GetMassDataAllLeasingOffers]);
        clearCheckedLeasingOffers();
      }
    });
    setIsLoading(false);
  };

  return (
    <div>
      <Text>Möchtest Du wirklich {leasingOffersId.length} Datensatz/-sätze archivieren?</Text>

      <Flex top='20' justify='space-between'>
        <Button transparent onClick={closeAlert}>
          <Flex align='center'>
            <ThinArrowLeft />
            <Text left='8' as='span'>
              Abbrechen
            </Text>
          </Flex>
        </Button>
        <Button onClick={deactivateLeasingOffers} secondary>
          Archivieren
        </Button>
      </Flex>
    </div>
  );
};

export default DeactivationModal;
